import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TagsComponent } from 'components/input/tags/tags.component';
import { CardComponent } from 'components/layout/card/card.component';
import { InputType } from 'enums/InputType';
import { TaskActionType } from 'enums/TaskActionType';
import { SelectListItemModel } from 'models/SelectList';
import { TaskTemplateModel } from 'models/generated/Entities.GormCrm.TaskTemplate';
import { TaskTemplateTagModel } from 'models/generated/Entities.GormCrm.TaskTemplateTag';
import { Inputs } from 'modules/inputs';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { TaskService } from 'services/task.service';

@Component({
	selector: 'task-template',
	templateUrl: './task-template.component.html',
	imports: [Layout, Inputs, TagsComponent, TranslatePipe]
})
export class TaskTemplateComponent {
	
	@Input() taskTemplate = new TaskTemplateModel();
	@Input() taskTemplateTags: TaskTemplateTagModel[] = [];
	@Output() public removed = new EventEmitter<void>();

	inputTypeEnum = InputType;
	taskType = TaskActionType;
	taskTypeList: SelectListItemModel[] = [];

	private _selectedType?= undefined;
	get selectedType() {
		if (this.taskTemplate.id)
			return this.taskTemplate.type;
		return this._selectedType;
	}
	set selectedType(type: any) {
		if (type) {
			this._selectedType = type;
			this.taskTemplate.type = type;
		}
	}

	constructor(private readonly taskService: TaskService) {
		this.taskTypeList = this.taskService.getTaskActionTypes(true);
	}
}

@Component({
	selector: 'task-templates',
	templateUrl: './task-templates.component.html',
	imports: [Layout, CardComponent, TaskTemplateComponent, TranslatePipe]
})
export class TaskTemplatesComponent {

	@Input() taskTemplates: TaskTemplateModel[] = [];
	@Input() taskTemplateTags: TaskTemplateTagModel[] = [];

	private formValidationService = inject(FormValidationService);

	addNewTask() {
		this.taskTemplates.push(new TaskTemplateModel());
		this.formValidationService.fieldStateChanged(this, true, false);
	}
	removeTask(task: TaskTemplateModel) {
		this.taskTemplates.splice(this.taskTemplates.indexOf(task), 1);
		this.formValidationService.fieldStateChanged(this, true, false);
	}
	markAsPristine() { }
}
